import React from 'react';

export default function CardToolbar({ title, children }) {
	return <div className="card-toolbar">
		<h2>{title}</h2>
		<div className="card-toolbar-right">
			{children}
		</div>
	</div>;
}